export const travel = {
  travelQuoteSelectedPlan: (state) => {
    if (state.quotation.travelForm.travelType && state.quotation.travelForm.planNo && state.quotation.travelParam.plans.plans && state.quotation.travelParam.plans.plans.length > 0) {
      const selectedPlan = state.quotation.travelParam.plans.plans.find(x => x.planNo === state.quotation.travelForm.planNo && x.subPlan === state.quotation.travelForm.travelType)
      if (selectedPlan) {
        return selectedPlan
      }
    }
    return null
  }
}
